import { useState } from "react"
import { Screen } from "./App"
import { ApiError, promoCodeCheck } from "./api"
import { useT } from "@transifex/react"

export const PromoCodeScreen = ({
  onComplete,
  onFailure,
}: {
  onComplete: (nextScreen: Screen, promoCode: string) => void
  onFailure: (nextScreen: Screen, errorMessage?: string) => void
}) => {
  const t = useT()
  const [promoCode, setPromoCode] = useState("")
  const [loading, setLoading] = useState(false)
  const [inputError, setInputError] = useState<string>()
  const [apiError, setApiError] = useState<string>()

  const submitPromoCode = async () => {
    setApiError(undefined)

    if (promoCode.length === 0) {
      setInputError(t("Please enter a promo code"))
      return
    }

    setLoading(true)
    try {
      await promoCodeCheck(promoCode)
      onComplete(Screen.Email, promoCode)
    } catch (error) {
      if (error instanceof ApiError) {
        onFailure(Screen.Failed, error.message)
      } else {
        setApiError(t("Something went wrong, please try again."))
      }
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      {apiError !== undefined && <p className="App-api-error">{apiError}</p>}
      <p className="App-description">
        {t("Please enter your promo code here.")}
      </p>
      <form
        onSubmit={(event) => {
          event.preventDefault()
          submitPromoCode()
        }}
      >
        <input
          className="App-input"
          type="text"
          value={promoCode}
          placeholder={t("Promo code")}
          onChange={(event) => {
            setPromoCode(event.target.value)
            setApiError(undefined)
            setInputError(undefined)
          }}
        />
        {inputError !== undefined && (
          <p className="App-input-error">{inputError}</p>
        )}
        {loading ? (
          <div className="loader" />
        ) : (
          <input
            className="App-button"
            type="submit"
            value={t("Redeem promo code")}
            disabled={loading}
          />
        )}
      </form>
    </>
  )
}
